import React, { forwardRef } from "react";
import { cn } from "./cn";

/**
 * Canonical inline Bun action. Use an anchor for navigation and
 * `as="button"` for an in-place text action. `tone="primary"` uses primary text.
 */
const TextLink = forwardRef(function TextLink(
  { as: Component = "a", type, muted = false, tone, size = "inherit", className, children, ...props },
  ref
) {
  return (
    <Component
      ref={ref}
      type={Component === "button" ? type || "button" : undefined}
      className={cn(
        "inline-flex items-center min-h-11 sm:min-h-0 p-0 border-0 bg-transparent font-instrument font-strong no-underline cursor-pointer",
        "focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bun-blue",
        size === "meta" ? "text-bun-meta" : "text-[length:inherit]",
        tone === "primary"
          ? "text-bun-text hover:text-bun-text"
          : muted
          ? "text-bun-stone hover:text-bun-text"
          : "text-bun-blue hover:text-bun-blue-hover",
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
});

export default TextLink;
